import RolePlayReviewDetailComponent from "../../components/NewDesign/RolePlay/RolePlayReviewDetailComponent"
import Page from "../../components/Page"

const RolePlayReviewDetailPage = () => {
    return (
        <Page>
            <RolePlayReviewDetailComponent />
        </Page>
    )
}

export default RolePlayReviewDetailPage